import { Grid, Typography } from '@material-ui/core';
import classNames from 'classnames';
import React, { FC } from 'react';

import { Success } from 'src/Icons';

import useStyles from './styles';

interface StyledOptionProps {
  innerProps: unknown;
  isDisabled: boolean;
  isFocused: boolean;
  isSelected: boolean;
  label: string;
  innerRef?: () => void;
  data: {
    id: number;
    disabledMessage?: string;
    label: string;
    value: unknown;
  };
}

/**
 * @internal
 */
export const StyledOption: FC<StyledOptionProps> = ({
  innerProps,
  innerRef,
  isFocused,
  isSelected,
  label,
  isDisabled,
  data: { disabledMessage },
}) => {
  const styles = useStyles();

  const labelText = isDisabled && disabledMessage ? `${label} - ${disabledMessage}` : label;

  return (
    <Grid
      ref={innerRef}
      alignItems="center"
      className={classNames(styles.option, {
        focused: isFocused,
        inactive: isDisabled,
        selected: isSelected,
      })}
      container
      justify="space-between"
      {...(innerProps as object)}
    >
      <Typography
        className={classNames(styles.optionLabel, {
          disabled: isDisabled,
          selected: isSelected,
        })}
        color="textPrimary"
        title={label}
        variant="body2"
      >
        {labelText}
      </Typography>
      {isSelected && <Success className={styles.checkmark} />}
    </Grid>
  );
};

/**
 * @internal
 */
export default StyledOption;
